export const activeDotStyle = (isDark: boolean) => {
	return {
		fill: isDark ? '#FFF' : '#565963',
		stroke: isDark ? '#FFF' : '#565963',
		strokeWidth: 3,
		r: 2
	}
}
